import {DatabaseNotification} from '@app/core/models/databaseNotification.model';
import {INotificationNumbers} from '@app/core/services/auth.service';

export interface INotificationsState {
	isLoading: boolean;
	notifications: DatabaseNotification[];
	notificationNumbers: INotificationNumbers;
	showNotifications: boolean;
}

export const initialNotificationsState: INotificationsState = {
	isLoading: false,
	notifications: [],
	notificationNumbers: {
		conversation_to_messages: {},
		conversations: 0,
		dashboard: 0,
		message_board_posts: 0,
		shifts: 0,
		sick_messages: 0,
		availabilities: 0,
		total_amount_of_notifications: 0,
	},
	showNotifications: false,
};
